import { makeStyles, Skeleton } from '@fluentui/react-components';
import { useResponsiveBreakpoint, } from '@office-start/dom-utility';
import { RecommendedFileCardControlSkeleton } from '@office-start/recommended-card-control';
import React, { useCallback, useMemo } from 'react';
import { responsiveBreakpointsHome } from './responsive';
var getItemDimensionsForBreakpoint = function (breakpoint) {
    return responsiveBreakpointsHome[breakpoint];
};
var useStyles = makeStyles({
    container: {
        paddingTop: '20px',
    },
    cardContainer: {
        display: 'flex',
        paddingLeft: '2px',
        paddingRight: '50px',
        height: '300px',
        marginBottom: '50px',
    },
    header: {
        height: '32px',
        marginBottom: '12px',
    },
});
var cardKeys = [1, 2, 3, 4, 5];
export var RecommendedControlSkeleton = function () {
    var breakpoint = useResponsiveBreakpoint();
    var itemDimensions = useMemo(function () {
        return getItemDimensionsForBreakpoint(breakpoint);
    }, [breakpoint]);
    var renderItem = useCallback(function (key) {
        return (React.createElement("div", { key: key, style: {
                marginRight: '20px',
                flexGrow: 1,
            } },
            React.createElement(RecommendedFileCardControlSkeleton, { width: itemDimensions.width, height: itemDimensions.height, maxWidth: itemDimensions.maxWidth, minWidth: itemDimensions.minWidth })));
    }, [itemDimensions]);
    var numCards = useMemo(function () {
        switch (breakpoint) {
            case 'ExtraExtraExtraLarge':
                return 5;
            case 'ExtraExtraLarge':
                return 4;
            case 'ExtraLarge':
                return 3;
            case 'Large':
                return 2;
            case 'Medium':
            case 'Small':
                return 1;
        }
    }, [breakpoint]);
    var styles = useStyles();
    return (React.createElement(Skeleton, null,
        React.createElement("div", { className: styles.container },
            React.createElement("div", { className: styles.header }),
            React.createElement("div", { className: styles.cardContainer }, cardKeys.map(function (key) {
                return key <= numCards ? renderItem(key) : null;
            })))));
};
//# sourceMappingURL=RecommendedSkeleton.js.map